<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-contact-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 23c5.52 0 10-4.477 10-10S25.52 3 20 3 10 7.477 10 13s4.48 10 10 10zM2 38c0-6.627 5.37-12 12-12h12c6.63 0 12 5.373 12 12v5.077c0 1.105-.9 2-2 2H4c-1.1 0-2-.895-2-2V38z"/><path d="M45 18H35a1 1 0 00-1 1v2a1 1 0 001 1h10a1 1 0 001-1v-2a1 1 0 00-1-1zm0 8h-4a1 1 0 00-1 1v2a1 1 0 001 1h4a1 1 0 001-1v-2a1 1 0 00-1-1z"/></svg>
</template>
<script>

export default {
  name: 'IconContactFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
